import React from 'react';
import CreateRide from '../CreateRide/CreateRide';

export const EditDraft = (props) => <CreateRide isDraftEditMode {...props} />;
